<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      
      <ul class="ulmenu">
          <li :class="item.class" v-for="(item,index) in menulists" :key="index" @click="changemenu(index)">{{item.name}}</li>
      </ul>
      <div class="bbackborder1">
          
          <!-- 商品销售信息分析 -->
          <el-col :span="24" v-show="selectmenus==0">
              <el-form :inline="true" class="demo-form-inline" size="small">
                  <el-form-item style="width:8%">
                      <el-select v-model="query.timetype" clearable remote  filterable placeholder="请选时间类型" @change="changetimetype">
                          <el-option v-for="(item,index) in timetypelists" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select>      
                  </el-form-item>
                  
                  <!-- 年份 -->
                  <el-form-item style="width:11%" v-if="query.timetype==1">
                      <el-date-picker v-model="query.date1" type="year" placeholder="开始日期" format="yyyy" value-format="yyyy" style="width:100%" @change="ischange=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:11%" v-if="query.timetype==1">
                      <el-date-picker v-model="query.date2" type="year" placeholder="开始日期" format="yyyy" value-format="yyyy" style="width:100%" @change="ischange=true"></el-date-picker>
                  </el-form-item>
                  <!-- 月份 -->
                  <el-form-item style="width:11%" v-if="query.timetype==2">
                      <el-date-picker v-model="query.date1" type="month" placeholder="开始日期" format="yyyy-MM" value-format="yyyy-MM" style="width:100%" @change="ischange=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:11%" v-if="query.timetype==2">
                      <el-date-picker v-model="query.date2" type="month" placeholder="开始日期" format="yyyy-MM" value-format="yyyy-MM" style="width:100%" @change="ischange=true"></el-date-picker>
                  </el-form-item>
                  <!-- 日期 -->
                  <el-form-item style="width:11%" v-if="query.timetype==3">
                      <el-date-picker v-model="query.date1" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="ischange=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:11%" v-if="query.timetype==3">
                      <el-date-picker v-model="query.date2" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="ischange=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:8%" v-if="$cookies.get('agentid')==36">
                    <el-select v-model="query.datafrom" clearable remote  filterable placeholder="请选择订单来源" @change="ischange=true">
                        <el-option v-for="(item,index) in datafromlists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>      
                  </el-form-item>
                  <el-form-item style="width:8%" v-if="$cookies.get('agentid')==36">
                    <el-select v-model="query.type" clearable remote  filterable placeholder="商品类型" @change="ischange=true">
                        <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                  </el-form-item> 
                  <el-form-item style="width:10%">
                      <el-select v-model="query.brandid" filterable clearable placeholder="按品牌"  @change="ischange=true">
                          <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                              <span style="float: left">{{item.name}}</span>
                              <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                          </el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item style="width:15%">
                      <el-input placeholder="商品名称 / sku" clearable v-model="query.key" @keyup.enter.native="goodsanalyse" @change="ischange=true" style="width:100%"></el-input>
                  </el-form-item>
                  <el-form-item style="width:15%">
                      <el-input placeholder="店铺 / 客户名称 / 手机" clearable v-model="query.customerkey" @keyup.enter.native="goodsanalyse" @change="ischange=true" style="width:100%"></el-input>
                  </el-form-item>
                  <el-form-item style="width:10%">
                      <el-select v-model="query.sorttype" clearable remote  filterable placeholder="请选择排序类型" @change="ischange=true" style="width:100%">
                          <el-option v-for="(item,index) in goodssort" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select>      
                  </el-form-item>
                  <el-form-item style="width:10%">
                      <el-select v-model="query.sort" clearable remote  filterable placeholder="请选择排序类型" @change="ischange=true" style="width:100%">
                          <el-option v-for="(item,index) in sortlists" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select> 
                  </el-form-item>
                   <el-form-item style="width:18%">
                      <el-button type="primary" icon="el-icon-search" @click="goodsanalyse">查询</el-button>
                      <el-button type="success" icon="el-icon-download" @click="getexportdata" v-if="$cookies.get('agentid')==36">导出</el-button>
                  </el-form-item>
              </el-form>

              <div style="margin-top:10px">
                  <el-table :data="goodslists" v-loading="goodslistsloading">
                      <el-table-column label="商品信息" align="left">
                          <template slot-scope="scope">
                              <div style="float:left;width:8%">
                                  <i style="padding:.1rem .4rem;background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-size:.1rem;font-style:normal;margin:-.6rem" v-if="scope.row.type=='京东' && $cookies.get('agentid')==36 ">JD</i>
                                  <i style="padding:.1rem .4rem;background:#67C23A;border-color:#67C23A;color:#fff;border-radius:50%;position:absolute;font-size:.1rem;font-style:normal;margin:-.6rem" v-if="scope.row.type=='宠赞' && $cookies.get('agentid')==36">CZ</i>
                                  <img :src="scope.row.thumb" style="float:left;width:100%;height:60px;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
                              </div>
                              <div style="float:left;width:86%;margin-left:2%">
                                  <span style="float:left;width:100%;font-size:.8rem">{{scope.row.productname}}</span>
                                  <span style="float:left;width:100%;color:#909399;font-size:.8rem" v-if="scope.row.spec!=''">规格：{{scope.row.propertyname}}</span>
                                  <span style="float:left;width:100%;color:#909399;font-size:.8rem" v-if="scope.row.sku!='' && scope.row.sku!=null">sku：{{scope.row.sku}}</span>
                              </div>
                          </template>
                      </el-table-column>
                      <el-table-column prop="brandname" label="品牌" width="120" align="center"></el-table-column>
                      <el-table-column prop="ordernums" label="订单数量" width="120" align="center"></el-table-column>
                      <el-table-column prop="customernums" label="客户数量" width="120" align="center"></el-table-column>
                      <el-table-column prop="salenums" label="销售数量" width="120" align="center"></el-table-column>
                      <el-table-column prop="totals" label="销售金额" width="120" align="center"></el-table-column>
                      <el-table-column label="操作" align="center" width="100">
                          <template slot-scope="scope">
                              <el-button size="mini" type="primary" icon="el-icon-search" circle @click="getgoodsales(scope.row)"></el-button>
                          </template>
                      </el-table-column>
                  </el-table>
                  <div class="block">
                      <!--分页begin-->
                      <el-pagination
                          @size-change="goodspageChange"
                          @current-change="goodspageCurrentChange"
                          :current-page="query.p"
                          :page-sizes="[10, 20, 50]"
                          :page-size="query.rollpage"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="goodsrows">
                      </el-pagination>
                      <!--分页end-->
                  </div>
              </div>
          </el-col>
          
          <!-- 客户销售信息分析 -->
          <el-col :span="24" v-show="$cookies.get('agentid')==36 && selectmenus==1">
              
              <el-form :inline="true" class="demo-form-inline" size="small">
                  <el-form-item style="width:8%">
                      <el-select v-model="customerquery.timetype" clearable remote  filterable placeholder="请选时间类型" @change="changetimetype1">
                          <el-option v-for="(item,index) in timetypelists" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select>      
                  </el-form-item>
                  
                  <!-- 年份 -->
                  <el-form-item style="width:11%" v-if="customerquery.timetype==1">
                      <el-date-picker v-model="customerquery.date1" type="year" placeholder="开始日期" format="yyyy" value-format="yyyy" style="width:100%" @change="ischange1=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:11%" v-if="query.timetype==1">
                      <el-date-picker v-model="customerquery.date2" type="year" placeholder="开始日期" format="yyyy" value-format="yyyy" style="width:100%" @change="ischange1=true"></el-date-picker>
                  </el-form-item>
                  <!-- 月份 -->
                  <el-form-item style="width:11%" v-if="customerquery.timetype==2">
                      <el-date-picker v-model="customerquery.date1" type="month" placeholder="开始日期" format="yyyy-MM" value-format="yyyy-MM" style="width:100%" @change="ischange1=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:11%" v-if="customerquery.timetype==2">
                      <el-date-picker v-model="customerquery.date2" type="month" placeholder="开始日期" format="yyyy-MM" value-format="yyyy-MM" style="width:100%" @change="ischange1=true"></el-date-picker>
                  </el-form-item>
                  <!-- 日期 -->
                  <el-form-item style="width:11%" v-if="customerquery.timetype==3">
                      <el-date-picker v-model="customerquery.date1" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="ischange1=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:11%" v-if="customerquery.timetype==3">
                      <el-date-picker v-model="customerquery.date2" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="ischange1=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:8%">
                    <el-select v-model="customerquery.datafrom" clearable remote  filterable placeholder="请选择订单来源" @change="ischange1=true">
                        <el-option v-for="(item,index) in datafromlists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>      
                  </el-form-item>
                  <el-form-item style="width:10%">
                      <el-select v-model="customerquery.sorttype" clearable remote  filterable placeholder="请选择排序类型" @change="ischange1=true" style="width:100%">
                          <el-option v-for="(item,index) in goodssort1" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select>      
                  </el-form-item>
                  <el-form-item style="width:10%">
                      <el-select v-model="customerquery.sort" clearable remote  filterable placeholder="请选择排序类型" @change="ischange1=true" style="width:100%">
                          <el-option v-for="(item,index) in sortlists" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select> 
                  </el-form-item>
                  <el-form-item style="width:15%">
                      <el-input placeholder="店铺 / 客户名称 / 手机" clearable v-model="customerquery.customerkey" @keyup.enter.native="getcustomeranalyse" @change="ischange1=true" style="width:100%"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" icon="el-icon-search" @click="getcustomeranalyse">查询</el-button>
                      <el-button type="success" icon="el-icon-download" @click="getcustomerexportdata">导出</el-button>
                  </el-form-item>
              </el-form>
              <div style="margin-top:10px">
                  <el-table :data="ctlists" v-loading="customerlistsloading">
                      <el-table-column prop="shopname" label="店铺名称" align="left"></el-table-column>
                      <el-table-column prop="ordernums" label="采购次数" width="120" align="center"></el-table-column>
                      <el-table-column prop="payprices" label="支付金额" width="120" align="center"></el-table-column>
                      <el-table-column prop="profit" label="销售利润" width="120" align="center"></el-table-column>
                      <el-table-column label="操作" align="center" width="100">
                          <template slot-scope="scope">
                              <el-button size="mini" type="primary" icon="el-icon-search" circle @click="getcustomerorders(scope.row)"></el-button>
                          </template>
                      </el-table-column>
                  </el-table>
                  <div class="block">
                      <!--分页begin-->
                      <el-pagination
                          @size-change="customerpageChange"
                          @current-change="customerpageCurrentChange"
                          :current-page="customerquery.p"
                          :page-sizes="[10, 20, 50]"
                          :page-size="customerquery.rollpage"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="customerows">
                      </el-pagination>
                      <!--分页end-->
                  </div>
              </div>
          </el-col>


        <!-- 品牌销售信息分析 -->
          <el-col :span="24" v-show="($cookies.get('agentid')==36 && selectmenus==2) || ($cookies.get('agentid')!=36 && selectmenus==1)">
              
              <el-form :inline="true" class="demo-form-inline" size="small">
                  <el-form-item style="width:7%">
                      <el-select v-model="brandquery.timetype" clearable remote  filterable placeholder="请选时间类型" @change="changetimetype2">
                          <el-option v-for="(item,index) in timetypelists" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select>      
                  </el-form-item>
                  
                  <!-- 年份 -->
                  <el-form-item style="width:11%" v-if="brandquery.timetype==1">
                      <el-date-picker v-model="brandquery.date1" type="year" placeholder="开始日期" format="yyyy" value-format="yyyy" style="width:100%" @change="ischange2=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:11%" v-if="query.timetype==1">
                      <el-date-picker v-model="brandquery.date2" type="year" placeholder="开始日期" format="yyyy" value-format="yyyy" style="width:100%" @change="ischange2=true"></el-date-picker>
                  </el-form-item>
                  <!-- 月份 -->
                  <el-form-item style="width:11%" v-if="brandquery.timetype==2">
                      <el-date-picker v-model="brandquery.date1" type="month" placeholder="开始日期" format="yyyy-MM" value-format="yyyy-MM" style="width:100%" @change="ischange2=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:11%" v-if="brandquery.timetype==2">
                      <el-date-picker v-model="brandquery.date2" type="month" placeholder="开始日期" format="yyyy-MM" value-format="yyyy-MM" style="width:100%" @change="ischange2=true"></el-date-picker>
                  </el-form-item>
                  <!-- 日期 -->
                  <el-form-item style="width:11%" v-if="brandquery.timetype==3">
                      <el-date-picker v-model="brandquery.date1" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="ischange2=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:11%" v-if="brandquery.timetype==3">
                      <el-date-picker v-model="brandquery.date2" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="ischange2=true"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="width:10%">
                      <el-select v-model="brandquery.brandid" filterable clearable placeholder="按品牌"  @change="ischange2=true">
                          <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                              <span style="float: left">{{item.name}}</span>
                              <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                          </el-option>
                      </el-select>
                  </el-form-item>
                 
                  <el-form-item style="width:7%" v-if="$cookies.get('agentid')==36">
                    <el-select v-model="brandquery.datafrom" clearable remote  filterable placeholder="选择渠道" @change="ischange2=true">
                        <el-option v-for="(item,index) in datafromlists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>      
                  </el-form-item>

                  <el-form-item style="width:7%" v-if="$cookies.get('agentid')==36">
                    <el-select v-model="brandquery.type" clearable remote  filterable placeholder="商品类型" @change="ischange2=true">
                        <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                  </el-form-item> 
                
                <el-form-item style="width:12%">
                      <el-input placeholder="店铺 / 客户名称 / 手机" clearable v-model="brandquery.customerkey" @keyup.enter.native="getbrandanalyse" @change="ischange2=true" style="width:100%"></el-input>
                  </el-form-item>
                  <el-form-item style="width:8%">
                      <el-select v-model="brandquery.sorttype"  remote  filterable placeholder="请选择排序类型" @change="ischange2=true" style="width:100%">
                          <el-option v-for="(item,index) in goodssort2" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select>      
                  </el-form-item>
                  <el-form-item style="width:7%">
                      <el-select v-model="brandquery.sort"  remote  filterable placeholder="请选择排序类型" @change="ischange2=true" style="width:100%">
                          <el-option v-for="(item,index) in sortlists" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select> 
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" icon="el-icon-search" circle @click="getbrandanalyse"></el-button>
                      <el-button type="success" icon="el-icon-download" circle @click="getbrandexportdata" v-if="$cookies.get('agentid')==36"></el-button>
                  </el-form-item>
              </el-form>
                
                <el-form-item style="width:12%">
                      <el-input placeholder="店铺 / 客户名称 / 手机" clearable v-model="brandquery.customerkey" @keyup.enter.native="getbrandanalyse" @change="ischange2=true" style="width:100%"></el-input>
                  </el-form-item>
                  <el-form-item style="width:8%">
                      <el-select v-model="brandquery.sorttype"  remote  filterable placeholder="请选择排序类型" @change="ischange2=true" style="width:100%">
                          <el-option v-for="(item,index) in goodssort2" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select>      
                  </el-form-item>
                  <el-form-item style="width:7%">
                      <el-select v-model="brandquery.sort"  remote  filterable placeholder="请选择排序类型" @change="ischange2=true" style="width:100%">
                          <el-option v-for="(item,index) in sortlists" :label="item.name" :value="item.id" :key="index"></el-option>
                      </el-select> 
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" icon="el-icon-search" circle @click="getbrandanalyse"></el-button>
                      <el-button type="success" icon="el-icon-download" circle @click="getbrandexportdata" v-if="$cookies.get('agentid')==36"></el-button>
                  </el-form-item>
              </el-form>

              <div style="margin-top:10px">
                  <el-table :data="brlists" v-loading="brandlistsloading">
                      <el-table-column label="品牌信息" align="left">
                      <template slot-scope="scope">
                          <div style="float:left;width:15%">
                              <img :src="scope.row.thumb" style="float:left;width:100%;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
                          </div>
                          <div style="float:left;width:36%;margin-left:2%">
                              <span style="float:left;width:100%;font-size:.8rem">{{scope.row.brandname}}</span>
                          </div>
                      </template>
                      </el-table-column>
                      <el-table-column prop="ordernums" label="采购次数" align="center" width="120"></el-table-column>
                      <el-table-column prop="shopnums" label="采购客户数" width="120" align="center"></el-table-column>
                      <el-table-column prop="allreals" label="支付金额" width="120" align="center"></el-table-column>
                      <el-table-column prop="allprofit" label="销售利润" width="120" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
                      <el-table-column label="操作" align="center" width="100">
                          <template slot-scope="scope">
                              <el-button size="mini" type="primary" icon="el-icon-search" circle @click="getbranddetails(scope.row)"></el-button>
                          </template>
                      </el-table-column>
                  </el-table>
                  <div class="block">
                      <el-pagination
                          @size-change="brandpageChange"
                          @current-change="brandpageCurrentChange"
                          :current-page="brandquery.p"
                          :page-sizes="[10, 20, 50]"
                          :page-size="brandquery.rollpage"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="brandrows">
                      </el-pagination>
                  </div>
              </div>
          </el-col>





          <!-- 导出商品分析信息确认 -->
          <el-dialog title="导出商品销售统计信息确认" :visible.sync="exportgoodsDialog" width="90%" top="5vh">
              <el-button size="medium" type="danger" @click="customeroutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
              <div id="outputorder">
                  <el-table :data="exportgoods" border v-loading="exportgoodsLoading">
                      <el-table-column prop="productname" label="商品名称" align="left"></el-table-column>
                      <el-table-column prop="propertyname" label="规格" width="120" align="left"></el-table-column>
                      <el-table-column prop="sku" label="商品sku" width="120" align="left"></el-table-column>
                      <el-table-column prop="brandname" label="品牌" width="120" align="left"></el-table-column>
                      <el-table-column prop="ordernums" label="订单数量" width="120" align="center"></el-table-column>
                      <el-table-column prop="customernums" label="客户数量" width="120" align="center"></el-table-column>
                      <el-table-column prop="salenums" label="销售数量" width="120" align="center"></el-table-column>
                      <el-table-column prop="totals" label="销售金额" width="120" align="center"></el-table-column>
                  </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                  <el-button size="medium" @click="exportgoodsDialog=false">取 消</el-button>
                  <el-button size="medium" type="danger" @click="customeroutput">确认导出</el-button>
              </div>	                
          </el-dialog>
          
          <!-- 商品销售详情 -->
          <el-dialog :title="goodsdetailname" :visible.sync="goodsdetailDialog" width="90%" top="5vh">
              <div id="outputorder">
                  <el-table :data="goodsdetaillists" border v-loading="goodsdetailLoading">
                      <el-table-column prop="ordernumber" label="订单编号" ></el-table-column>
                      <el-table-column prop="shopname" label="客户" ></el-table-column>
                      <el-table-column prop="dataf" label="销售来源" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
                      <el-table-column prop="price" label="价格" align="center"></el-table-column>
                      <el-table-column prop="numbers" label="数量" align="center"></el-table-column>
                      <el-table-column prop="totals" label="小计" align="center"></el-table-column>
                      <el-table-column prop="inputtime" label="下单时间" align="center"></el-table-column>
                  </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                  <el-button size="medium" @click="goodsdetailDialog=false">取 消</el-button>
              </div>	                
          </el-dialog>

          <!-- 客户销售订单详情 -->
          <el-dialog :title="customerdetailname" :visible.sync="customerdetailDialog" width="90%" top="5vh">
              <div id="outputorder">
                  <el-table :data="ctdlists" border v-loading="customerdetailloading">
                      <el-table-column type="expand">
                          <template slot-scope="props">
                          <div style="float:left;width:100%;padding:15px 0 15px 1%;background:#fff;border-bottom:1px solid #ebeef5">
                              收货人姓名： {{props.row.truename}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              收货人电话： {{props.row.phone}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;		
                              支付方式：
                              <span v-if="props.row.paystatus==1" style="text-align:center">支付宝</span>
                              <span v-if="props.row.paystatus==7" style="text-align:center">微信</span>
                              <span v-if="props.row.paystatus==8" style="text-align:center">银联</span>
                              <span v-if="props.row.paystatus==5" style="text-align:center">透支</span>
                              <span v-if="props.row.paystatus==9" style="text-align:center">线下支付</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              地址信息：{{props.row.defauladdress}}<br/>
                              详细地址：{{props.row.address}}
                          </div>
                          <el-table :data="props.row.goods">
                               <el-table-column prop="productname" label="商品名称"></el-table-column>
                               <el-table-column prop="propertyname" label="规格" width="210" align="left"></el-table-column>
                               <el-table-column prop="price" label="单价" width="100" align="center"></el-table-column>
                               <el-table-column prop="numbers" label="数量" width="100" align="center"></el-table-column>
                               <el-table-column prop="total" label="总价" width="100" align="center"></el-table-column>
                          </el-table>
                      </template>
                      </el-table-column>

                      <el-table-column prop="ordernumber" label="订单编号"></el-table-column></el-table-column>
                      <el-table-column prop="shopname" label="店铺名称"></el-table-column></el-table-column>
                      <el-table-column prop="type" label="订单来源"></el-table-column></el-table-column>		
                      <el-table-column label="订单金额" prop="oriprices" width="100" align="center"></el-table-column>
				      <el-table-column label="支付金额" prop="prices" width="100" align="center"></el-table-column>
				      <el-table-column label="支付方式" prop="paytype" width="100" align="center"></el-table-column>		
				      <el-table-column label="是否支付" prop="ispay" width="110" align="center"></el-table-column>
				      <el-table-column label="下单时间" prop="inputtime" width="140" align="center"></el-table-column>
                  </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                  <el-button size="medium" @click="customerdetailDialog=false">取 消</el-button>
              </div>	                
          </el-dialog>

          <!-- 导出客户分析信息确认 -->
          <el-dialog title="导出客户销售统计信息确认" :visible.sync="customerexportDialog" width="90%" top="5vh">
              <el-button size="medium" type="danger" @click="customeroutputexport" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
              <div id="outputorder">
                  <el-table :data="ctexportlists" border v-loading="customerexportlistsloading">
                      <el-table-column prop="shopname" label="店铺名称" align="left"></el-table-column>
                      <el-table-column prop="ordernums" label="采购次数" width="120" align="center"></el-table-column>
                      <el-table-column prop="payprices" label="支付金额" width="120" align="center"></el-table-column>
                      <el-table-column prop="profit" label="销售利润" width="120" align="center"></el-table-column>
                  </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                  <el-button size="medium" @click="customerexportDialog=false">取 消</el-button>
                  <el-button size="medium" type="danger" @click="customeroutputexport">确认导出</el-button>
              </div>	                
          </el-dialog>

          <!-- 导出品牌分析信息确认 -->
          <el-dialog title="导出品牌销售统计信息确认" :visible.sync="brandexportDialog" width="90%" top="5vh">
              <el-button size="medium" type="danger" @click="brandoutputexport" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
              <div id="outputorder">
                  <el-table :data="brexportlists" border v-loading="brandexportlistsloading">
                      <el-table-column prop="brandname" label="品牌名称" align="left"></el-table-column>
                      <el-table-column prop="ordernums" label="采购次数" width="120" align="center"></el-table-column>
                      <el-table-column prop="shopnums" label="采购店铺数" width="120" align="center"></el-table-column>
                      <el-table-column prop="allreals" label="支付金额" width="120" align="center"></el-table-column>
                      <el-table-column prop="allprofit" label="利润" width="120" align="center"></el-table-column>
                  </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                  <el-button size="medium" @click="brandexportDialog=false">取 消</el-button>
                  <el-button size="medium" type="danger" @click="brandoutputexport">确认导出</el-button>
              </div>	                
          </el-dialog>

          <!-- 导出品牌分析信息明细确认 -->
          <el-dialog title="导出品牌销售统计信息明细确认" :visible.sync="branddetailexportDialog" width="90%" top="5vh">
              <el-button size="medium" type="danger" @click="branddetailsoutputexport" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
              <div id="outputorder">
                  <el-table :data="brdexportlists" border v-loading="branddetailexportlistsloading">
                      <el-table-column prop="shopname" label="店铺名称" align="left"></el-table-column>
                      <el-table-column prop="ordernums" label="采购次数" width="120" align="center"></el-table-column>
                      <el-table-column prop="allreals" label="支付金额" width="120" align="center"></el-table-column>
                      <el-table-column prop="allprofit" label="利润" width="120" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
                  </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                  <el-button size="medium" @click="branddetailexportDialog=false">取 消</el-button>
                  <el-button size="medium" type="danger" @click="branddetailsoutputexport">确认导出</el-button>
              </div>	                
          </el-dialog>


      </div>     
          
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Mallstat/index",
      transitionshow:true,
      isexport:false,
      query: {
          act:'goodsanalyse',
          token:this.$cookies.get('token'),
          date1:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
          date2:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
          timetype:'3',
          sorttype:'1',
          sort:'1',
          datafrom:'',
          type:'',
          brandid:'',
          key:'',
          customerkey:'',
          p:1,
          rollpage:10,
          isexport:0,
      },
      timetypelists:[{id:'1',name:'年份'},{id:'2',name:'月份'},{id:'3',name:'日期'}],
      goodssort:[{id:'1',name:'销售金额排序'},{id:'2',name:'销售数量排序'},{id:'3',name:'订单数量排序'},{id:'4',name:'客户数量排序'}],
      goodssort1:[{id:'1',name:'按采购次数排序'},{id:'2',name:'按支付金额排序'},{id:'3',name:'按销售利润排序'}],
      goodssort2:[{id:'1',name:'按采购次数排序'},{id:'2',name:'按支付金额排序'},{id:'3',name:'按采购客户数量排序'},{id:'4',name:'按销售利润排序'}],
      sortlists:[{id:'1',name:'降序'},{id:'2',name:'升序'}],
      datafromlists:[{id:1,name:'商城订单'},{id:2,name:'分销订单'}],
      typelists:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
      brandlists:[],
      
      menulists:this.$cookies.get('agentid')==36 ? 
                [{id:1,name:'商品销售分析',class:'limenu'},{id:2,name:'客户销售分析',class:'limenu'},{id:3,name:'品牌销售分析',class:'limenu'}] : 
                [{id:1,name:'商品销售分析',class:'limenu'},{id:2,name:'品牌销售分析',class:'limenu'}],
      classdefault:"limenu",
      selectdefault:"limenu on",
      selectmenus:'',
      goodsmaxheight:{'max-height':'2.5rem','transition':"all .3s",'overflow':'hidden'},

      goodslistsloading:false,
      goodslists:[],
      goodsrows:0,
      exportgoods:[],
      exportgoodsDialog:false,
      exportgoodsLoading:false,
      exportdatas:[],
      exporthead:[],
      exportfield:[],
      exportname:'',
      goodsdetaillists:[],
      goodsdetailDialog:false,
      goodsdetailLoading:false,
      goodsdetailname:'',
      
      ischange1:false,
      customerlistsloading:false,
      customerows:0,
      ctlists:[],
      customerquery: {
          act:'customersanalyse',
          token:this.$cookies.get('token'),
          date1:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
          date2:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
          timetype:'3',
          sorttype:'1',
          sort:'1',
          datafrom:'',
          customerkey:'',
          p:1,
          rollpage:10,
          isexport:0,
      },
      customerdetailDialog:false,
      customerdetailloading:false,
      ctdlists:[],
      customerdetailname:'',
      customerexportlistsloading:false,
      customerexportDialog:false,
      ctexportlists:[],

      brandquery: {
          act:'brandsanalyse',
          token:this.$cookies.get('token'),
          date1:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
          date2:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
          timetype:'3',
          sorttype:'1',
          sort:'1',
          datafrom:'',
          customerkey:'',
          brandid:'',
          type:'',
          p:1,
          rollpage:10,
          isexport:0,
      },
      ischange2:false,
      brandlistsloading:false,
      brlists:[],
      brandrows:0,
      brandexportDialog:false,
      brandexportlistsloading:false,
      brexportlists:[],
      branddetailexportDialog:false,
      branddetailexportlistsloading:false,
      brdexportlists:[],


    }  
  },
  mounted(){
     this.getBrand(); //获取品牌信息
     this.goodsanalyse(); //获取分析商品
     this.changemenu(0);
  },
  methods:{

      /** 切换菜单 **/
      changemenu(index) {
          var _this=this;
          this.menulists.forEach(function(item,i) {index==i ? _this.menulists[i].class='limenu on' : _this.menulists[i].class='limenu'});
          this.selectmenus=index;
          
          if(index==0) { //按商品销售分析
              this.query.timetype='3';
              this.query.sorttype='1';
              this.query.sort='1';
              this.query.datafrom='';
              this.query.type='';
              this.query.brandid='';
              this.query.key='';
              this.query.p=1;
              this.query.rollpage=10;
              this.query.isexport=0;
              //this.goodsanalyse();

          }else { //按客户销售分析
            
          }

      },

      /** 获取商品销分析信息 **/
      goodsanalyse() {
          if(this.ischange==true) {this.query.p=1;this.query.rollpage=10;}
          this.goodslistsloading=true;
          var resource = this.$resource(this.url);
          this.query.isexport=0;
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.goodslistsloading=false;
              }else{
                  this.goodslists = JSON.parse(Base64.decode(res.data.Data));
	              this.goodsrows=parseInt(res.data.count);
                  if(this.ischange==true) this.ischange=false;
                  this.goodslistsloading=false;
              }
          }).catch((res) => {
              this.goodslistsloading=false;
          });
      },

      goodspageChange(val) {
        this.query.rollpage = val;
        this.goodsanalyse();
      },
      goodspageCurrentChange(val) {
        this.query.p = val;
        this.goodsanalyse();
      },


      /** 获取销售详情信息 **/
      getgoodsales(item) {
          this.goodsdetailDialog=true;
          this.goodsdetailLoading=true;
          this.goodsdetailname=item.productname+'（规格：'+item.propertyname+'）销售详情';
          var resource = this.$resource(this.url);
          resource.query({act:'goodsdetailanalyse',token:this.$cookies.get('token'),productid:item.productid,propertyid:item.propertyid,date1:this.query.date1,date2:this.query.date2,timetype:this.query.timetype,sorttype:this.query.sorttype,sort:this.query.sort,datafrom:this.query.datafrom,type:this.query.type,brandid:this.query.brandid,key:this.query.key,customerkey:this.query.customerkey}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.goodsdetailLoading=false;
              }else{
                  this.goodsdetaillists = JSON.parse(Base64.decode(res.data.Data));
                  this.goodsdetailLoading=false;
              }
          }).catch((res) => {
              this.goodsdetailLoading=false;
          });
      },


      /** 导出商品信息 **/
      getexportdata() {
          this.exportgoodsDialog=true;
          this.exportgoodsLoading=true;
          var resource = this.$resource(this.GLOBAL.exportUrl+"Mallstat/index");
          this.query.isexport=1;
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.exportgoodsLoading=false;
              }else{
                  this.exportgoods = JSON.parse(Base64.decode(res.data.Data));
                  this.exportgoodsLoading=false;
              }
          }).catch((res) => {
              this.exportgoodsLoading=false;
          });
      },


      /** 获取客户销售分析 **/
      getcustomeranalyse() {
          if(this.ischange1==true) {this.customerquery.p=1;this.customerquery.rollpage=10;}
          this.customerlistsloading=true;
          var resource = this.$resource(this.url);
          this.customerquery.isexport=0;
          resource.query(this.customerquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.customerlistsloading=false;
              }else{
                  this.ctlists = JSON.parse(Base64.decode(res.data.Data));
	              this.customerows=parseInt(res.data.count);
                  if(this.ischange1==true) this.ischange1=false;
                  this.customerlistsloading=false;
              }
          }).catch((res) => {
              this.customerlistsloading=false;
          });
      },

      customerpageChange(val) {
        this.customerquery.rollpage = val;
        this.getcustomeranalyse();
      },
      customerpageCurrentChange(val) {
        this.customerquery.p = val;
        this.getcustomeranalyse();
      },


      /** 导出客户销售分析 **/
      getcustomerexportdata() {
          this.customerexportDialog=true;
          this.customerexportlistsloading=true;
          var resource = this.$resource(this.GLOBAL.exportUrl+"Mallstat/index");
          this.customerquery.isexport=1;
          resource.query(this.customerquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.customerexportlistsloading=false;
              }else{
                  this.ctexportlists = JSON.parse(Base64.decode(res.data.Data));
                  this.customerexportlistsloading=false;
              }
          }).catch((res) => {
              this.customerexportlistsloading=false;
          });
      },


      /** 导出品牌销售数据 **/
      getbrandexportdata() {
          this.brandexportDialog=true;
          this.brandexportlistsloading=true;
          var resource = this.$resource(this.GLOBAL.exportUrl+"Mallstat/index");
          this.brandquery.isexport=1;
          resource.query(this.brandquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.brandexportlistsloading=false;
              }else{
                  this.brexportlists = JSON.parse(Base64.decode(res.data.Data));
                  this.brandexportlistsloading=false;
              }
          }).catch((res) => {
              this.brandexportlistsloading=false;
          });
      },


      /**  导出品牌销售数据明细 **/
      getbranddetails(item) {
          this.branddetailexportDialog=true;
          this.branddetailexportlistsloading=true;
          var resource = this.$resource(this.GLOBAL.exportUrl+"Mallstat/index");
          resource.query({act:'brandsanalysedetail',token:this.$cookies.get('token'),date1:this.brandquery.date1,date2:this.brandquery.date2,timetype:this.brandquery.timetype,sorttype:this.brandquery.sorttype,sort:this.brandquery.sort,datafrom:this.brandquery.datafrom,customerkey:this.brandquery.customerkey,brandid:item.brandid,type:this.brandquery.type}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.branddetailexportlistsloading=false;
              }else{
                  this.brdexportlists = JSON.parse(Base64.decode(res.data.Data));
                  this.branddetailexportlistsloading=false;
              }
          }).catch((res) => {
              this.branddetailexportlistsloading=false;
          });
      },


      /** 客户销售分析订单详情 **/
      getcustomerorders(item) {
          this.customerdetailname=item.shopname+"销售订单详情";
          this.customerdetailDialog=true;
          this.customerdetailloading=true;
          var resource = this.$resource(this.url);
          resource.query({act:'customersanalysedetail',token:this.$cookies.get('token'),date1:this.customerquery.date1,date2:this.customerquery.date2,timetype:this.customerquery.timetype,datafrom:this.customerquery.datafrom,customerkey:this.customerquery.customerkey,shopid:item.shopid}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.customerdetailloading=false;
              }else{
                  this.ctdlists = JSON.parse(Base64.decode(res.data.Data));
                  this.customerdetailloading=false;
              }
          }).catch((res) => {
              this.customerdetailloading=false;
          });
      },




      //按商品导出销售分析数据
      customeroutput() {
    	  this.exporthead=['商品名称','规格','商品sku','品牌','订单数量','客户数量','销售数量','销售金额'];
	      this.exportfield=['productname','propertyname','sku','brandname','ordernums','customernums','salenums','totals'];
	      this.exportname='商品销售统计信息';
          this.exportdatas=this.exportgoods;
	      this.exportput();
	      this.exportgoodsDialog=false;		
      },

      //按客户导出销售分析数据
      customeroutputexport() {
          this.exporthead=['店铺名称','采购次数','支付金额','销售利润'];
	      this.exportfield=['shopname','ordernums','payprices','profit'];
	      this.exportname='客户销售统计信息';
          this.exportdatas=this.ctexportlists;
	      this.exportput();
	      this.customerexportDialog=false;		
      },

      //按品牌导出销售分析数据
      brandoutputexport() {
          this.exporthead=['品牌名称','采购次数','采购店铺数','支付金额','销售利润'];
	      this.exportfield=['brandname','ordernums','shopnums','allreals','allprofit'];
	      this.exportname='品牌销售统计信息';
          this.exportdatas=this.brexportlists;
	      this.exportput();
	      this.brandexportDialog=false;		
      },

      //按品牌导出销售详情分析数据
      branddetailsoutputexport() {
          this.exporthead=['店铺名称','采购次数','支付金额','销售利润'];
	      this.exportfield=['shopname','ordernums','allreals','allprofit'];
	      this.exportname='品牌销售统计明细信息';
          this.exportdatas=this.brdexportlists;
	      this.exportput();
	      this.branddetailexportDialog=false;		
      },


      /** 确认导出信息 **/
      exportput() {
		  require.ensure([], () => {
			  var { export_json_to_excel } = require('../../vendor/Export2Excel');
			  var data = this.formatJson(this.exportfield, this.exportdatas);
			  export_json_to_excel(this.exporthead, data, this.exportname);
		  })
      },
    
      //导出表格数据
	  formatJson(filterVal, jsonData) {
　　　　  return jsonData.map(v => filterVal.map(j => v[j]));
　　  },


      /** 展开、收起搜索条件 **/
      showandclosegoods() {
          if(this.goodsmaxheight['max-height']=='2.5rem') {
              this.goodsmaxheight['max-height']='5.5rem';
          }else {
              this.goodsmaxheight['max-height']='2.5rem';
          }
      },

      /** 获取品牌 **/
	    getBrand(){
	        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
	        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		        	var _this=this;
		            var result = JSON.parse(Base64.decode(res.data.Data));
		            this.brandlists=[];
		            result.forEach(function(e,i) {
		            	_this.brandlists.push({id:e.id,name:e.name,py:e.py,showlable:e.showlable});
		            });
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
	    },

        /** 修改时间类型 **/
        changetimetype() {
            this.ischange=true;
            this.query.date1='';
            this.query.date2='';
        },

        /** 修改时间类型 **/
        changetimetype1() {
            this.ischange1=true;
            this.customerquery.date1='';
            this.customerquery.date2='';
        },

        /** 修改时间类型 **/
        changetimetype2() {
            this.ischange2=true;
            this.brandquery.date1='';
            this.brandquery.date2='';
        },


        /** 获取客户销售分析 **/
        getbrandanalyse() {
            if(this.ischange2==true) {this.brandquery.p=1;this.brandquery.rollpage=10;}
            this.brandlistsloading=true;
            var resource = this.$resource(this.url);
            this.brandquery.isexport=0;
            resource.query(this.brandquery).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.brandlistsloading=false;
                }else{
                    this.brlists=[];
                    this.brlists = JSON.parse(Base64.decode(res.data.Data));
                    this.brandrows=parseInt(res.data.count);
                    if(this.ischange2==true) this.ischange2=false;
                    this.brandlistsloading=false;
                }
            }).catch((res) => {
                this.brandlistsloading=false;
            });
        },

        brandpageChange(val) {
            this.brandquery.rollpage = val;
            this.getbrandanalyse();
        },
        brandpageCurrentChange(val) {
            this.brandquery.p = val;
            this.getbrandanalyse();
        },


  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.bbackborder1 {float:left;width:98%;overflow:hidden;background:#fff;border-radius:5px;border:1px solid #ddd;padding:1% 1% 3% 1%;margin-top:-1px}
.ulmenu {padding:0 0 0 1%;margin:0;float:left;width:100%;z-index:100;position:relative}
.limenu {cursor:pointer;float:left;padding:.2rem .5rem;font-size:.7rem;border-radius:5px 5px 0 0;list-style-type:none;border:1px solid #ddd;background:rgb(221,221,221,.9);color:#fff;margin-left:8px;transition: all .3s}
.on {background:#fff;border-bottom:1px solid #fff;padding:.2rem 1rem;color:#606266}
</style>


// WEBPACK FOOTER //
// src/components/mall/Mallsaleanalyse.vue